import { useEffect, useState } from "react";
import { UtensilsCrossed } from "lucide-react";
import { imgSrc, imgSrcSet } from "@/lib/media";

export const DishImage = ({ url, alt, sizes, priority = false, size = "md" }) => {
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    setFailed(false);
  }, [url]);

  if (!url || failed) {
    return (
      <div className="absolute inset-0 grid place-items-center" style={{ background: "linear-gradient(135deg, var(--wt-surface), var(--wt-card))" }}>
        <UtensilsCrossed className="h-8 w-8 opacity-30" />
      </div>
    );
  }
  return (
    <img
      src={imgSrc(url, size)}
      srcSet={imgSrcSet(url)}
      sizes={sizes}
      alt={alt}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      onError={() => setFailed(true)}
      className="absolute inset-0 h-full w-full object-cover"
    />
  );
};
